import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import styled, { css, createGlobalStyle } from 'styled-components';
import React from 'react';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      @media (min-width: ", "em) {\n        ", ";\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        @media (max-width: ", "em) {\n          ", ";\n        }\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var sizes = {
  forSmallOnly: {
    max: true,
    width: 680
  },
  forSmallMediumOnly: {
    max: true,
    width: 991
  },
  forMediumUp: {
    max: false,
    width: 681
  },
  forLargeUp: {
    max: false,
    width: 992
  } // Iterate through the sizes and create a media template

};
var media = Object.keys(sizes).reduce(function (acc, label) {
  acc[label] = function () {
    if (sizes[label].max) {
      return css(_templateObject(), sizes[label].width / 16, css.apply(void 0, arguments));
    }

    return css(_templateObject2(), sizes[label].width / 16, css.apply(void 0, arguments));
  };

  return acc;
}, {});

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n      font-size: ", ";\n    "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n  }\n\n  html {\n    font-size: ", ";\n\n    ", "\n  }\n\n  body {\n    font-family: ", ";\n    color: ", ";\n    background-color: ", ";\n\n    h1, h2, h3, h4, h5, h6 {\n      margin-top: 0;\n      margin-bottom: 0.5rem;\n      color: ", ";\n      font-family: ", ";\n      font-weight: 400;\n    }\n\n    h1 {\n      font-size: 1.7rem;\n    }\n\n    h2 {\n      font-size: 1.4rem;\n    }\n\n    hr {\n      box-sizing: content-box;\n      height: 0;\n      overflow: visible;\n    }\n\n    p {\n      margin-top: 0;\n      margin-bottom: 1rem;\n      line-height: ", ";\n    }\n\n    a {\n      color: ", ";\n      text-decoration: none;\n\n      &:visited {\n        color: ", ";\n      }\n    }\n\n    ol ol,\n    ul ul,\n    ol ul,\n    ul ol {\n      margin-bottom: 0;\n    }\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * Some of this pulled from Bootstrap's source:
 * https://github.com/twbs/bootstrap/blob/master/dist/css/bootstrap.css
 */


var GlobalStyle = createGlobalStyle(_templateObject$1(), function (props) {
  return props.theme.defaultFontSize;
}, media.forSmallOnly(_templateObject2$1(), function (props) {
  return props.theme.defaultMobileFontSize;
}), function (props) {
  return props.theme.defaultFont;
}, function (props) {
  return props.theme.defaultFontColor;
}, function (props) {
  return props.theme.bodyBackgroundColor;
}, function (props) {
  return props.theme.defaultHeaderColor;
}, function (props) {
  return props.theme.defaultHeaderFont;
}, function (props) {
  return props.theme.defaultParagraphLineHeight;
}, function (props) {
  return props.theme.linkColor;
}, function (props) {
  return props.theme.linkColor;
});

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n      padding-right: 15px;\n      padding-left: 15px;\n\n      @media (min-width: 576px) {\n        max-width: 540px;\n      }\n\n      @media (min-width: 768px) {\n        max-width: 720px;\n      }\n\n      @media (min-width: 992px) {\n        max-width: 960px;\n      }\n\n      @media (min-width: 1200px) {\n        max-width: ", ";\n      }\n    "]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n\n  ", "\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var Container = styled.div(_templateObject$2(), function (_ref) {
  var fluid = _ref.fluid;
  return !fluid && css(_templateObject2$2(), function (props) {
    return props.theme.maxContainerWidth;
  });
});
var ThemeContext = React.createContext();
var DEFAULT_THEME = {
  defaultFont: '"Helvetica Neue", Arial, "Noto Sans"',
  defaultFontColor: '#090728',
  defaultFontSize: '18px',
  defaultHeaderColor: '#333333',
  defaultHeaderFont: '"Helvetica Neue", Arial, "Noto Sans"',
  defaultInputBackgroundColor: '#f5f5f5',
  defaultMobileFontSize: '16px',
  defaultTransition: 'all 0.2s linear',
  defaultParagraphLineHeight: '1.15',
  desktopHeaderHeight: '80px',
  disabledColor: '#888888',
  errorColor: '#e44100',
  focusColor: '#4c9aff',
  grayText: '#959595',
  linkColor: '#2f74ce',
  maxContainerWidth: '1140px',
  mobileHeaderHeight: '60px',
  negativeColor: '#cc432a',
  positiveColor: '#52b74d',
  primaryColor: '#010628',
  white: '#ffffff'
};

var CalderaDigitalThemeProvider = function CalderaDigitalThemeProvider(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? {} : _ref$theme,
      children = _ref.children;
  return React.createElement(ThemeContext.Provider, {
    value: _objectSpread({}, DEFAULT_THEME, theme)
  }, children);
};

var CalderaDigitalThemeConsumer = ThemeContext.Consumer;

var getTheme = function getTheme(Component) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(GetTheme, _React$Component);

    function GetTheme() {
      _classCallCheck(this, GetTheme);

      return _possibleConstructorReturn(this, _getPrototypeOf(GetTheme).apply(this, arguments));
    }

    _createClass(GetTheme, [{
      key: "render",
      value: function render() {
        var _this = this;

        return React.createElement(ThemeContext.Consumer, null, function (theme) {
          return React.createElement(Component, Object.assign({}, _this.props, {
            theme: theme
          }));
        });
      }
    }]);

    return GetTheme;
  }(React.Component);
};

export { CalderaDigitalThemeConsumer, CalderaDigitalThemeProvider, Container, DEFAULT_THEME, GlobalStyle, getTheme, media };